import { Layer, path, View } from '@hscmap/stellar-globe';
import { Bridge } from '..';

interface IAddPolygon {
  type: 'add_polygon'
  args: {
    id: string,
    paths: path.Path[],
  }
}

interface IDeletePolygon {
  type: 'remove_polygon'
  args: {
    id: string,
  }
}

class PolygonLayer extends Layer {
  private renderer!: path.Renderer

  constructor(private paths: path.Path[]) {
    super()
  }

  onAdd() {
    this.renderer = new path.Renderer(this.globe.gl)
    this.renderer.setPaths(this.paths)
    this.renderer.darkenNarrowLine = false
    this.renderer.minWidth = 3
  }

  onRemove() {
    this.renderer.release()
  }

  render(view: View) {
    this.renderer.render(view)
  }

  setPaths(paths: path.Path[]) {
    this.paths = paths
    this.renderer.setPaths(this.paths)
  }
}

const registry: { [id: string]: PolygonLayer } = {}

export async function add_polygon(b: Bridge, msg: IAddPolygon) {
  const { id, paths } = msg.args
  const layer = new PolygonLayer(paths)
  registry[id] = layer
  b.globe.addLayer(layer)
}

export function remove_polygon(b: Bridge, msg: IDeletePolygon) {
  const { id } = msg.args
  const layer = registry[id]
  if (layer) {
    b.globe.removeLayer(layer)
    delete registry[id]
  }
}
